import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse } from './indicacao.types';

export const putIndicacaoPagamento = async (id: number, paga: boolean) => {
	try {
		const response = await BaseClient.put<IndicacaoApiResponse<string>>(
			`v2/Indicacao/Solicitacao/${id}/Pagamento`,
			{ paga }
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<string>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
